import { ListGroup, Popover } from "react-bootstrap";
import {
  AiFillCloseCircle,
  AiFillEdit,
  AiFillPrinter,
  AiOutlineDiff,
  AiOutlineSafety,
} from "react-icons/ai";
import { BsFileEarmarkCheckFill, BsXLg } from "react-icons/bs";
import {
  FaDochub,
  FaFileExport,
  FaFileImport,
  FaFileSignature,
  FaRegComment,
} from "react-icons/fa";
import {
  FcCheckmark,
  FcDisclaimer,
  FcReadingEbook,
  FcTwoSmartphones,
} from "react-icons/fc";
import { TbTimelineEvent } from "react-icons/tb";

export const IconName = {
  /**
   * แก้ไข ส่งอ่าน
   */
  PATIENT_EDITOR: { id: 1, text: "แก้ไข/ส่งอ่าน" },
  PRINT_REPORT: { id: 2, text: "พิมพ์ผล" },
  FINAL_DIAG_INFORM: { id: 3, text: "แจ้ง Final Diagnosis" },
  MARK_AS_VERIFY: { id: 4, text: "Marks as Verified" },
  CHECK_STUDY_PROGRESS: { id: 5, text: "ตรวจสอบ TIME-LINE" },
  PAST_EXTERNAL_REPORT: { id: 6, text: "วางผลจากภายนอก (ปิดเคส)" },
  STUDY_REVIEWS: { id: 7, text: "ส่ง REVIEW อีกครั้ง" },
  BILLING_ISSUED: { id: 8, text: "ออกเอกสาร" },
  SET_OLD_STUDY: { id: 9, text: "ส่ง Study เก่า" },
  CANCEL_STUDY: { id: 10, text: "ยกเลิกเคส" },

  /** Radiologirst Toggle Menu */
  RADI_ACCEPT_CASE: { id: 20, text: "รับเคส" },
  RADI_REJECT_CASE: { id: 22, text: "ปฏิเสธ" },
  RADI_DIAG_REPORT: { id: 21, text: "อ่านผล" },
  RADI_EDIT_REPORT: { id: 23, text: "แก้ไขผล" },
  RADI_CONFERRENCE: { id: 24, text: "แจ้ง CONFERRENCE" },
  RADI_INFORM_PROBLEM: { id: 25, text: "แจ้งปัญหา" },
  /** Common Use */
  RETURN_NOACTION: { id: 31, text: "กลับ" },
};

const styles = {
  icon: { color: "#10b981", marginRight: "15px" },
  listItem: { color: "#242323", padding: "5px" },
  buttonFilter: { marginRight: "2px" },
};
/**
 *
 * @param {*} iconName
 * @param {*} style
 * @returns
 */
export const GetMenu = (icon, style) => {
  // console.log("The icon is ", icon);
  switch (icon.id) {
    case IconName.PATIENT_EDITOR.id:
      return <AiFillEdit style={styles.icon} />;
    case IconName.PRINT_REPORT.id:
      return <AiFillPrinter style={styles.icon} />;
    case IconName.FINAL_DIAG_INFORM.id:
      return <AiOutlineSafety style={styles.icon} />;
    case IconName.MARK_AS_VERIFY.id:
      return <BsFileEarmarkCheckFill style={styles.icon} />;
    case IconName.CHECK_STUDY_PROGRESS.id:
      return <TbTimelineEvent style={styles.icon} />;
    case IconName.PAST_EXTERNAL_REPORT.id:
      return <FaFileImport style={styles.icon} />;
    case IconName.STUDY_REVIEWS.id:
      return <FaFileExport style={styles.icon} />;
    case IconName.BILLING_ISSUED.id:
      return <FaDochub style={styles.icon} />;
    case IconName.SET_OLD_STUDY.id:
      return <AiOutlineDiff style={styles.icon} />;
    case IconName.CANCEL_STUDY.id:
      return <BsXLg style={styles.icon} />;

    case IconName.RADI_ACCEPT_CASE.id:
      return <FcCheckmark style={styles.icon} />;

    case IconName.RADI_DIAG_REPORT.id:
      return <FcReadingEbook style={styles.icon} />;

    case IconName.RADI_EDIT_REPORT.id:
      return <FaFileSignature style={styles.icon} />;

    case IconName.RADI_CONFERRENCE.id:
      return <FcTwoSmartphones style={styles.icon} />;

    case IconName.RADI_INFORM_PROBLEM.id:
      return <FaRegComment style={styles.icon} />;

    case IconName.RADI_REJECT_CASE.id:
      return <FcDisclaimer style={styles.icon} />;
    case IconName.RETURN_NOACTION.id:
      return <AiFillCloseCircle style={styles.icon} />;

    default:
      return <AiFillEdit style={styles.icon} />;
  }
};

export const BuildMenuItem = (icon, onClick, disabled) => {
  return { icon: icon, onClick: onClick, disabled };
};

/**
 * Create Context-Menu container
 * @param {} menuItems
 * @returns
 */
export const BuildContextItem = (menuItems) =>
  new Promise((resolve, reject) => {
    //if (menuItems == null) resolve([]);
    resolve(
      <Popover id="popover-basic" style={{ minWidth: "300px" }}>
        <Popover.Header
          style={{ background: "#10b981", color: "#f4f4ff" }}
          as="h3"
        >
          เลือกรายการ
        </Popover.Header>
        <Popover.Body style={{ pading: "0 0 0 0px" }}>
          {menuItems.map((item, i) => (
            <ListGroup.Item
              style={styles.listItem}
              action
              variant="light"
              disabled={item.disabled}
              hidden={item.hidden}
              onClick={item.onClick}
            >
              {GetMenu(item.icon)}
              {item.icon.text}
            </ListGroup.Item>
          ))}
        </Popover.Body>
      </Popover>
    );
  });
